import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { GqlSpecials } from 'types/graphql';
import OffersCarouselCard from 'shared/components/specials/offers-carousel-card';
import useUI from 'src/hooks/use-ui';
import usePaths from 'src/hooks/use-paths';
import { SpecialOfferCard } from 'src/components/special-offer-card';
import { CarouselV2 } from '../carousel-v2';

type OfferCarouselProps = {
  offers: GqlSpecials[];
  href?: string;
  title: string;
  hideTitle?: boolean;
  hideLink?: boolean;
};

const getSpecialTypeRoute = (specialType?: string | null): string => (specialType === 'sale' ? 'sale' : 'offer');

export const OfferCarousel = ({ offers, href, title, hideTitle, hideLink }: OfferCarouselProps): JSX.Element => {
  const { isEmbeddedCarousel } = useUI();
  const flags = useFlags();
  const specialsRedesignEnabled = flags['ecomm.specials-redesign.rollout'] ?? false;
  const { href: specialsBasePath } = usePaths({ specials: true });

  return (
    <CarouselV2
      href={href}
      title={title}
      mt={isEmbeddedCarousel ? '0' : undefined}
      hideTitle={hideTitle}
      hideLink={hideLink}
    >
      {offers.map((offer, index) =>
        specialsRedesignEnabled ? (
          <SpecialOfferCard
            key={offer._id}
            special={offer}
            href={`${specialsBasePath}/${getSpecialTypeRoute(offer.specialType)}/${offer._id}`}
            role='group'
            aria-label={offer.menuDisplayName ?? offer.name ?? undefined}
            aria-roledescription='slide'
          />
        ) : (
          <OffersCarouselCard
            key={offer._id}
            aria-label={offer.menuDisplayName}
            aria-roledescription='slide'
            className={`offers ${index !== 0 && index + 1 === offers.length ? `last-card` : ``}`}
            isSingularCard={offers.length === 1}
            displayName={offer.menuDisplayName ?? offer.name}
            displayImage={offer.menuDisplayImage}
            role='group'
            specialId={offer._id}
            specialType={offer.specialType}
            width='100%'
            isUsingGapSpacing
          />
        )
      )}
    </CarouselV2>
  );
};
